import { withTranslations } from 'hooks/useTranslations'
import Component from './CartSummary'
import { graphql, useStaticQuery } from 'gatsby'
declare global {
  interface Snippets {
    'molecules-account-CartSummary': {
      deliveryinfomodal_shippingcost: void
      deliveryinfomodal_shippingcost_text: void
      promotioninput_voucher_input: void
      promotioninput_coupon_input: void
      promotioninput_voucher_not_eligable: void
      promotioninput_voucher_exluded_text: void
      promotioninput_voucher_success_text: void
      promotioninput_voucher_failure_text: {
        couponCode: string | number
      }
      to_checkout_text: void
      sharecart_share_text: void
      sharecart_share_explain_text: void
      sharecart_copied_indicator: void
      sharecart_copy_link: void
      sharecart_mail_incident: void
      sharecart_print_cart: void
      sharecart_close: void
      sharecart_errormodal_import_failed: void
      sharecart_errormodal_import_failed_explanation: void
      sharecart_errormodal_close: void
      paypal_overlay_b2c_label: void
      paypal_overlay_b2b_label: void
      order_minimum: {
        value: number
      }
      minimum_order_value: {
        value: string
        MINIMUMTEXT: any
        minimumValue: string
      }
    }
  }
}

export default withTranslations(Component, () =>
  useStaticQuery(graphql`
    query molecules_account_CartSummary_translations {
      paypal_overlay_b2c_label: snippet(
        group: "molecules-account-CartSummary"
        name: "paypal_overlay_b2c_label"
      )
      paypal_overlay_b2b_label: snippet(
        group: "molecules-account-CartSummary"
        name: "paypal_overlay_b2b_label"
      )
      deliveryinfomodal_shippingcost: snippet(
        group: "molecules-account-CartSummary"
        name: "deliveryinfomodal_shippingcost"
      )
      deliveryinfomodal_shippingcost_text: snippet(
        group: "molecules-account-CartSummary"
        name: "deliveryinfomodal_shippingcost_text"
      )
      promotioninput_voucher_input: snippet(
        group: "molecules-account-CartSummary"
        name: "promotioninput_voucher_input"
      )
      promotioninput_coupon_input: snippet(
        group: "molecules-account-CartSummary"
        name: "promotioninput_coupon_input"
      )
      promotioninput_voucher_exluded_text: snippet(
        group: "molecules-account-CartSummary"
        name: "promotioninput_voucher_exluded_text"
      )
      promotioninput_voucher_not_eligable: snippet(
        group: "molecules-account-CartSummary"
        name: "promotioninput_voucher_not_eligable"
      )
      promotioninput_voucher_success_text: snippet(
        group: "molecules-account-CartSummary"
        name: "promotioninput_voucher_success_text"
      )
      promotioninput_voucher_failure_text: snippet(
        group: "molecules-account-CartSummary"
        name: "promotioninput_voucher_failure_text"
      )
      to_checkout_text: snippet(
        group: "molecules-account-CartSummary"
        name: "to_checkout_text"
      )
      sharecart_share_text: snippet(
        group: "molecules-account-CartSummary"
        name: "sharecart_share_text"
      )
      sharecart_share_explain_text: snippet(
        group: "molecules-account-CartSummary"
        name: "sharecart_share_explain_text"
      )
      sharecart_copied_indicator: snippet(
        group: "molecules-account-CartSummary"
        name: "sharecart_copied_indicator"
      )
      sharecart_copy_link: snippet(
        group: "molecules-account-CartSummary"
        name: "sharecart_copy_link"
      )
      sharecart_mail_incident: snippet(
        group: "molecules-account-CartSummary"
        name: "sharecart_mail_incident"
      )
      sharecart_print_cart: snippet(
        group: "molecules-account-CartSummary"
        name: "sharecart_print_cart"
      )
      sharecart_close: snippet(
        group: "molecules-account-CartSummary"
        name: "sharecart_close"
      )
      sharecart_errormodal_import_failed: snippet(
        group: "molecules-account-CartSummary"
        name: "sharecart_errormodal_import_failed"
      )
      sharecart_errormodal_import_failed_explanation: snippet(
        group: "molecules-account-CartSummary"
        name: "sharecart_errormodal_import_failed_explanation"
      )
      sharecart_errormodal_close: snippet(
        group: "molecules-account-CartSummary"
        name: "sharecart_errormodal_close"
      )
      order_minimum: snippet(
        group: "molecules-account-CartSummary"
        name: "order_minimum"
      )
      minimum_order_value: snippet(
        group: "molecules-account-CartSummary"
        name: "minimum_order_value"
      )
    }
  `)
)
